<template>
  <div class="admin-dashboard">
    <!-- 侧边栏 -->
    <div class="sidebar">
      <div class="sidebar-header">
        <h2>管理后台</h2>
        <div class="admin-info">
          <span>{{ adminUser.username }}</span>
          <button class="logout-btn" @click="logout">退出</button>
        </div>
      </div>
      
      <nav class="sidebar-nav">
        <div 
          v-for="item in menuItems" 
          :key="item.path"
          class="nav-item"
          :class="{ active: currentPath === item.path }"
          @click="navigateTo(item.path)"
        >
          <i :class="item.icon"></i>
          <span>{{ item.name }}</span>
        </div>
      </nav>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content">
      <div class="content-header">
        <h1>{{ currentPageTitle }}</h1>
      </div>
      
      <div class="content-body">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminDashboard',
  data() {
    return {
      adminUser: {},
      menuItems: [
        {
          name: '网站概况',
          path: '/adminyuanhui66/dashboard',
          icon: 'fas fa-chart-bar'
        },
        {
          name: '新闻资讯',
          path: '/adminyuanhui66/news',
          icon: 'fas fa-newspaper'
        },
        {
          name: '公众号文章',
          path: '/adminyuanhui66/articles',
          icon: 'fas fa-file-alt'
        },
        {
          name: '版本管理',
          path: '/adminyuanhui66/versions',
          icon: 'fas fa-code-branch'
        }
      ]
    }
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    currentPageTitle() {
      const currentItem = this.menuItems.find(item => item.path === this.currentPath);
      return currentItem ? currentItem.name : '管理后台';
    }
  },
  mounted() {
    this.loadAdminUser();
  },
  methods: {
    loadAdminUser() {
      const adminUserStr = localStorage.getItem('adminUser');
      if (adminUserStr) {
        this.adminUser = JSON.parse(adminUserStr);
      }
    },
    navigateTo(path) {
      // 避免重复导航到当前路径
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    logout() {
      if (confirm('确定要退出登录吗？')) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        this.$router.push('/yuanhui66-login');
      }
    }
  }
}
</script>

<style scoped>
.admin-dashboard {
  display: flex;
  min-height: 100vh;
  background: #f5f7fa;
  overflow: hidden;
}

.sidebar {
  width: 250px;
  background: #2c3e50;
  color: white;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  overflow-y: auto;
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #34495e;
}

.sidebar-header h2 {
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
}

.admin-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.logout-btn {
  background: #e74c3c;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.3s;
}

.logout-btn:hover {
  background: #c0392b;
}

.sidebar-nav {
  flex: 1;
  padding: 20px 0;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s;
  border-left: 3px solid transparent;
}

.nav-item:hover {
  background: #34495e;
  border-left-color: #3498db;
}

.nav-item.active {
  background: #34495e;
  border-left-color: #3498db;
}

.nav-item i {
  margin-right: 12px;
  width: 16px;
  text-align: center;
}

.nav-item span {
  font-size: 14px;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 250px;
  background: #f5f7fa;
  min-height: 100vh;
}

.content-header {
  background: white;
  padding: 20px 30px;
  border-bottom: 1px solid #e1e8ed;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.content-header h1 {
  margin: 0;
  font-size: 24px;
  color: #2c3e50;
  font-weight: 600;
}

.content-body {
  flex: 1;
  padding: 30px;
  overflow-y: auto;
  background: #f5f7fa;
  min-height: calc(100vh - 80px); /* 减去header高度 */
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-dashboard {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .sidebar-nav {
    display: flex;
    overflow-x: auto;
    padding: 10px;
  }
  
  .nav-item {
    flex-shrink: 0;
    padding: 10px 15px;
    border-left: none;
    border-bottom: 3px solid transparent;
  }
  
  .nav-item.active {
    border-left-color: transparent;
    border-bottom-color: #3498db;
  }
}
</style> 